/* global Howl */
import {ADD_MESSAGE, ADD_FAKE_MESSAGE, SEND_MESSAGE} from '../actions';

const send = require('inbox-common/dist/statics/assets/audio/wm_message_sent_3.mp3');
const push = require('inbox-common/dist/statics/assets/audio/wm_message_push_6.mp3');
const receive = require('inbox-common/dist/statics/assets/audio/wm_message_recieve_1.mp3');

let sendSound, receiveSounds, pushSound;

const soundsMiddleware = () => {
  try {
    sendSound = new Howl({
      src: [send]
    });
    pushSound = new Howl({
      src: [push]
    });
    receiveSounds = new Howl({
      src: [receive]
    });
  } catch (e) {
    console.warn(e);
  }
  return () => next => action => {
    try {
      switch (action.type) {
        case ADD_MESSAGE:
        case ADD_FAKE_MESSAGE:
          document.hidden ? pushSound.play() : receiveSounds.play();
          break;
        case `${SEND_MESSAGE}_FULFILLED`:
          sendSound.play();
          break;
        default:
      }
    } catch (e) {
      console.warn(e);
    }
    return next(action);
  };
};

export default soundsMiddleware;



// WEBPACK FOOTER //
// ./chat-app/services/soundsMiddleware.js